import { useTranslations } from '@/i18n/translations';

import { downloadCsv } from '../../../lib/download';
import type { GroupRosterMember } from '../../../lib/views/groups';
import { buildRosterCsv, rosterCsvFilename, type RosterCsvLabels } from './roster-csv';

// Wires the roster CSV export for a member section: translated column labels
// in, a one-argument export handler out. Both the network and circle sections
// hand the result straight to `MembersTablePanel`'s `onExport`, which calls it
// with the rows the filters currently show.
export function useRosterExport(
  groupName: string,
  groupKind: 'network' | 'circle',
): (rows: ReadonlyArray<GroupRosterMember>) => void {
  const t = useTranslations('Group');
  const labels: RosterCsvLabels = {
    headers: {
      firstName: t('members.csv.firstName'),
      lastName: t('members.csv.lastName'),
      email: t('members.csv.email'),
      roleInGroup: t('members.csv.roleInGroup'),
      circles: t(`members.table.circles.${groupKind}`),
      otherNetworks: t(`members.table.otherNetworks.${groupKind}`),
      joined: t('members.table.joined'),
    },
    roleLeader: t('members.role.leader'),
    roleMember: t('members.role.member'),
  };

  return (rows) => {
    downloadCsv(
      rosterCsvFilename(groupName, new Date()),
      buildRosterCsv(rows, labels),
    );
  };
}
